<template>
  <div class="opple-control-area">
    <div class="border_title">
      {{ activeConfig?.name || $t('ifttt.associatedConfiguration') }}
    </div>
    <div class="opple-relate-container">
      <div
        v-if="configList.length > 1"
        class="opple-config-navBar"
      >
        <div
          v-for="(item, index) in configList"
          :key="index"
          class="opple-config-navBar_item"
          :class="{ active: activeIndex === index }"
          @click="activeIndex = index"
        >
          {{ item.name }}
        </div>
      </div>
      <div
        v-else
        class="opple-config-navBar opple-config-navBar--guide"
      >
        <!-- <p class="opple-config-navBar_desc">
          {{ $t('ifttt.associatedInfo') }}
        </p> -->
        <div class="opple-config-navBar_img-wrap">
          <img
            :src="$img('elfNotice3')"
            alt=""
          >
        </div>
      </div>
      <Platform
        ref="platform"
        :device="device"
        :gp-list="gpList"
        :area-config="activeConfig"
        @success="$emit('success')"
      />
    </div>
  </div>
</template>

<script>
import Platform from './components/Platform.vue';

export default {
  name: 'OppleControlArea',
  components: {
    Platform
  },
  props: {
    device: {
      type: Object,
      default: () => ({})
    },
    gpList: {
      type: Array,
      default: () => []
    },
    configList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: 0
    };
  },
  computed: {
    activeConfig() {
      return this.configList[this.activeIndex] || null;
    }
  },
  methods: {
    init() {
      this.$refs.platform?.init();
    }
  }
};
</script>

<style lang="scss">
.opple-control-area {
  .border_title {
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    color: #111;

    &::after {
      width: 2px;
      background-color: #0046aa;
      bottom: 0;
      content: "";
      position: absolute;
      left: 0;
      height: 16px;
    }
  }

  .opple-relate-container {
    display: flex;
    width: 100%;
    padding: 32px 0;
    justify-content: space-between;
    border: 1px solid #eee;
  }

  .opple-config-navBar {
    width: 200px;
    flex-shrink: 0;

    &--guide {
      width: 400px;
      padding: 0 12px 12px;
    }

    &_item {
      padding: 10px 12px;
      cursor: pointer;
      color: #606266;

      &.active {
        color: #0046aa;
        font-weight: 500;
      }
    }

    &_desc {
      padding: 9px;
      font-size: 14px;
      color: #9E9E9E;
    }

    &_img-wrap {
      width: 100%;
    }

    img {
      display: block;
      width: 100%;
      height: auto;
      object-fit: contain;
    }
  }
}
</style>
